module.exports = __webpack_public_path__ + "static/img/1048.f0abd94.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1048.jpg
// module id = 230
// module chunks = 0